<template>

<Cargos></Cargos>

</template>


<script>

import Cargos from '../../components/Cargos.vue';

export default {


 components:{

     Cargos

  }

}


</script>